import React from 'react';

interface ISvgIcon {
  color?: string;
}

const Share = ({color = "#FFF"} : ISvgIcon) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11.561" height="16.81" viewBox="0 0 11.561 16.81">
      <g id="Group_869" data-name="Group 869" transform="translate(-1289.75 -979.328)">
        <path id="Path_3648" data-name="Path 3648" d="M147.314,85.906h-3.2a.965.965,0,0,1-.764-.425,1.733,1.733,0,0,1-.317-1.026V74.417a1.727,1.727,0,0,1,.32-1.017.963.963,0,0,1,.761-.42h3.2v.39h-3.2a.7.7,0,0,0-.555.306,1.262,1.262,0,0,0-.235.741V84.456a1.266,1.266,0,0,0,.231.75.706.706,0,0,0,.559.311h3.2Z" transform="translate(1146.964 908.295)" fill={color} stroke={color} strokeWidth="0.5"/>
        <path id="Path_3649" data-name="Path 3649" d="M320.8,0h.291V16.31H320.8Z" transform="translate(973.41 979.578)" fill={color} stroke={color} strokeWidth="0.5"/>
        <path id="Path_3650" data-name="Path 3650" d="M416.36,85.906h-2.24v-.39h2.244a.705.705,0,0,0,.559-.311,1.266,1.266,0,0,0,.231-.75V74.417a1.266,1.266,0,0,0-.231-.75.705.705,0,0,0-.559-.311H414.12V72.98h2.244a.965.965,0,0,1,.764.425,1.732,1.732,0,0,1,.317,1.025V84.456a1.732,1.732,0,0,1-.318,1.028.963.963,0,0,1-.768.423Z" transform="translate(883.616 908.295)" fill={color} stroke={color} strokeWidth="0.5"/>
      </g>
    </svg>
  )
}

export default Share;